import * as React from "react";
import { createPortal } from 'react-dom';
import * as classNames from "classnames";

import { NotificationModal }  from "./NotificationModal";
import { Authorization } from "../misc/components/Authorization";
import { PermissionEnum } from "../misc/api/ApiPermissionEnum";
import { AlertNotification } from "webportalclient";
import { useSecurityContext } from "../Core/SecurityContext";
import { useWebPortalApiClient, WebPortalApiClient } from "../misc/api/WebPortalTokenClient";
import { useInterval } from "../misc/Hooks/UseInterval";
import { useCurrentStudyConfigurationContext } from "../Core/CurrentStudyConfigurationContext";

interface AlertNotificationPopoutProps {
    currentStudyId: string;
}

function AdjustFavicon(isNotifying: boolean) {
    let link = document.querySelector<HTMLLinkElement>("link[rel~='icon']");
    if (!link) {
        link = document.createElement('link');
        link.rel = 'icon';
        document.head.appendChild(link);
    }
    link.href = isNotifying ? '/favicon-alert.ico' : '/favicon.ico';
}

export const AlertNotificationPopout = (props: AlertNotificationPopoutProps) => {
    const { currentUserPermissions } = useSecurityContext();
    const client = useWebPortalApiClient();
    const { study } = useCurrentStudyConfigurationContext();
    const [unReadAlerts, setUnReadAlerts] = React.useState<AlertNotification[]>([]);
    const [modalOpen, setModalOpen] = React.useState<boolean>();
    const [isNotifying, setIsNotifying] = React.useState<boolean>(false);

    const getData = async (webPortalClient: WebPortalApiClient) => {
        const notifications = await webPortalClient.client.getAlertNotifications(undefined, `isRead eq false and (subscription/studyId eq ${study.id} or subscription/id eq null)`, undefined, "alert");

        if (unReadAlerts.length !== notifications.value.length) {
            setUnReadAlerts(notifications.value);
            setIsNotifying(true);
        }
    }

    React.useEffect(() => {
        getData(client);
    }, []);

    React.useEffect(() => {
        AdjustFavicon(isNotifying);
    }, [isNotifying]);

    useInterval(() => getData(client), 10000);

    const handleIconClick = () => {
        setModalOpen(!modalOpen);
    };

    const bellClasses = classNames("fas", "fa-bell", "fa-lg", {
        "alert-bell-off": !isNotifying,
        "alert-bell": isNotifying
    });

    const badgeClasses = classNames("badge", {
        "badge-primary": !isNotifying,
        "badge-info": isNotifying
    });

    if (!unReadAlerts)
        return null;

    return (
        <Authorization
            permissionId={PermissionEnum.ViewAlertNotifications}
            studyId={props.currentStudyId}
            currentPermissions={currentUserPermissions}
        >
            <li><a
                key="notificationMenu"
                id="notificationMenu"
                role="button"
                onClick={handleIconClick}
            >
                <span className={bellClasses} style={{ marginRight: 2 + "px" }} />
                <span className={badgeClasses}>{unReadAlerts.length}</span>
            </a></li>
            {modalOpen ?
                createPortal(<NotificationModal
                    key="notificationPanel"
                    alerts={unReadAlerts}
                    onRefresh={() => { getData(client); setIsNotifying(false); }}
                    isFetching={false}
                    onClose={() => { setModalOpen(false); setIsNotifying(false); }}
                />, document.body)
            : null}
        </Authorization>
    );
}


